import { Fragment } from 'react';
import { Tooltip, Typography } from "@mui/joy";
import { Link } from "react-router-dom";
import { useLanguageContext } from '../context/LanguageContext';

export function TooltipWithLink({ children, to, linkTitle, ...props }) {
  return <Fragment {...props}>
    <Typography fontSize="sm" color="white">{children}</Typography>
    <Link to={to} fontSize="sm" style={{ textDecoration: 'underline', fontWeight: 'normal', color: "white" }} target='_blank'>{linkTitle}</Link>
  </Fragment>
}
export function TooltipProbablyWithLink({ children, to, title }) {
  const { t } = useLanguageContext();
  return (
    to ?
      <Tooltip
        title={
          <TooltipWithLink to={to} linkTitle={t('Read more in knowledge base')}>
            {title}
          </TooltipWithLink>
        }>
        {children}
      </Tooltip>
      : <Tooltip title={title}>{children}</Tooltip>
  )
}